import { useEffect, useState } from "react";
import api from "../api/client";
import Icon from "./Icon";
import { useToast } from "../store/toast";

// Seguir / dejar de seguir una tarea o proyecto (Fase 2.4). Al seguir, sus
// cambios (comentarios, estado, tareas nuevas) llegan a tu pantalla de Actividad.
export default function FollowButton({ entityType, entityId, size = "sm" }) {
  const { push } = useToast();
  const [following, setFollowing] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!entityId) return;
    api.get(`/follows/${entityType}/${entityId}`)
      .then((r) => { if (alive) setFollowing(!!r.data.following); })
      .catch(() => { if (alive) setFollowing(false); });
    return () => { alive = false; };
  }, [entityType, entityId]);

  const toggle = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/follows/${entityType}/${entityId}`, { follow: !following });
      setFollowing(r.data.following);
      push(r.data.following ? "Ahora sigues esto" : "Dejaste de seguir", "success");
    } catch (e) {
      push(e.response?.data?.detail || "No se pudo actualizar", "error");
    } finally { setBusy(false); }
  };

  if (following === null) return null;
  const cls = following
    ? "border border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100"
    : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50";
  return (
    <button onClick={toggle} disabled={busy}
      className={`btn shadow-sm ${size === "xs" ? "text-[11px]" : "text-xs"} ${cls}`}
      title={following ? "Dejar de seguir" : "Seguir para recibir su actividad"}>
      <Icon name="star" size={size === "xs" ? 12 : 14} />
      {following ? "Siguiendo" : "Seguir"}
    </button>
  );
}
